var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTotalViewBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.4106C7.50797 20.4106 3.20699 17.1058 0.367971 13.6748C-0.122657 13.0818 -0.122657 12.2211 0.367971 11.6281C1.08177 10.7655 2.57762 9.10119 4.57584 7.64667C9.60876 3.98329 14.3814 3.97622 19.4241 7.64667C21.7716 9.3554 23.632 11.5961 23.632 11.6281C24.1226 12.2211 24.1226 13.0818 23.632 13.6748C20.7934 17.1053 16.493 20.4106 12 20.4106ZM12 6.37025C7.02376 6.37025 2.71013 11.1158 1.50663 12.5703C1.46774 12.6173 1.46774 12.6856 1.50663 12.7326C2.71017 14.1871 7.02376 18.9327 12 18.9327C16.9762 18.9327 21.2898 14.1871 22.4933 12.7326C22.5635 12.6478 22.4887 12.5703 22.4933 12.5703C21.2898 11.1158 16.9762 6.37025 12 6.37025Z",
    fill: "#B8B8B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 17.8241C9.14764 17.8241 6.82715 15.5036 6.82715 12.6513C6.82715 9.79901 9.14764 7.47852 11.9999 7.47852C14.8522 7.47852 17.1727 9.79901 17.1727 12.6513C17.1727 15.5036 14.8522 17.8241 11.9999 17.8241ZM11.9999 8.95645C9.96259 8.95645 8.30508 10.614 8.30508 12.6513C8.30508 14.6886 9.96259 16.3461 11.9999 16.3461C14.0373 16.3461 15.6948 14.6886 15.6948 12.6513C15.6948 10.614 14.0373 8.95645 11.9999 8.95645Z",
    fill: "#B8B8B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTotalViewBlog);
export default __webpack_public_path__ + "static/media/icon-total-view-blog.c72396f3b2aaa1481382029ecfb3cfba.svg";
export { ForwardRef as ReactComponent };